import React, { useEffect, useState } from "react";
import { IMAGE_URL } from "../../config/config";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useProducts } from "../../context/ProductContext";
import "./AllCourses.css";

const AllCourses = () => {
  const { products, categories, loading } = useProducts();

  const [selectedCat, setSelectedCat] = useState("All");
  const [courses, setCourses] = useState([]);
  const [filteredCourses, setFilteredCourses] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const coursesPerPage = 9;
  const navigate = useNavigate();
  const location = useLocation();

  // ✅ helper to read query
  const getQueryCategory = () => {
    const params = new URLSearchParams(location.search);
    return params.get("category");
  };

  console.log(courses, filteredCourses, selectedCat);

  // ✅ flatten products
  useEffect(() => {
    if (!products?.length) return;

    const allCourses = products.flatMap((cat) =>
      (cat.courses || []).map((course) => ({
        ...course,
        category_name: cat.category_name,
      }))
    );

    setCourses(allCourses);
    setFilteredCourses(allCourses);
  }, [products]);

  // ✅ AUTO FILTER FROM URL ⭐⭐⭐
  useEffect(() => {
    const queryCat = getQueryCategory();

    if (queryCat && courses.length) {
      setSelectedCat(queryCat);
      setCurrentPage(1);

      if (queryCat === "All") {
        setFilteredCourses(courses);
      } else {
        const filtered = courses.filter(
          (c) => c.category_name === queryCat
        );
        setFilteredCourses(filtered);
      }
    }
  }, [location.search, courses]);

  // ✅ manual category click
  const handleCategoryClick = (cat) => {
    setSelectedCat(cat);
    setCurrentPage(1);

    // ⭐ update URL (PRO UX)
    navigate(
      cat === "All"
        ? "/courses"
        : `/courses?category=${encodeURIComponent(cat)}`
    );

    if (cat === "All") {
      setFilteredCourses(courses);
    } else {
      const filtered = courses.filter((c) => c.category_name === cat);
      setFilteredCourses(filtered);
    }
  };

  const handleRegisterClick = (course) => {
    navigate(`/course/${course.product_name}`, { state: { course } });
  };

  // pagination
  const totalPages = Math.ceil(filteredCourses.length / coursesPerPage);
  const indexOfLastCourse = currentPage * coursesPerPage;
  const indexOfFirstCourse = indexOfLastCourse - coursesPerPage;
  const currentCourses = filteredCourses.slice(
    indexOfFirstCourse,
    indexOfLastCourse
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const renderPaginationNumbers = () => {
    const pages = [];
    const maxVisiblePages = 5;

    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 4; i++) pages.push(i);
        pages.push("...");
        pages.push(totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(1);
        pages.push("...");
        for (let i = totalPages - 3; i <= totalPages; i++)
          pages.push(i);
      } else {
        pages.push(1);
        pages.push("...");
        pages.push(currentPage - 1);
        pages.push(currentPage);
        pages.push(currentPage + 1);
        pages.push("...");
        pages.push(totalPages);
      }
    }

    return pages;
  };

  return (
    <section className="courses archive section">
      <div className="container">
        {/* CATEGORY FILTER */}
        <div className="category-filter mb-4 text-center">
          {categories?.map((cat) => (
            <button
              key={cat}
              className={`category-btn ${
                selectedCat === cat ? "active" : ""
              }`}
              onClick={() => handleCategoryClick(cat)}
            >
              {cat.toUpperCase()}
            </button>
          ))}
        </div>

        {/* COURSE GRID */}
        <div className="row">
          {loading ? (
            <div className="col-12 text-center py-5">
              Loading courses...
            </div>
          ) : currentCourses.length === 0 ? (
            <div className="col-12 text-center py-5">
              No courses found.
            </div>
          ) : (
            currentCourses.map((course) => (
              <div
                className="col-lg-4 col-md-6 col-12 mb-4"
                key={course.product_id}
              >
                <div className="single-course">
                  <div className="course-head overlay">
                    <img
                      src={`${IMAGE_URL}/uploads/${course.image}`}
                      alt={course.product_name}
                    />
                    <button
                      type="button"
                      onClick={() => handleRegisterClick(course)}
                      className="btn white primary"
                    >
                      Enroll Now
                    </button>
                  </div>

                  <div className="course-body">
                    <div className="name-price">
                      <span className="price">
                        ₹
                        {(() => {
                          try {
                            const parsed = JSON.parse(course.price);
                            return parsed[0]?.price || "0";
                          } catch {
                            return "0";
                          }
                        })()}
                      </span>
                    </div>

                    <h4 className="c-title">
                      <Link
                        to={`/course/${course.product_name}`}
                        state={{ course }}
                      >
                        {course.product_name}
                      </Link>
                    </h4>

                    <p>
                      {course.description
                        ? course.description.slice(0, 100) + "..."
                        : "No description available."}
                    </p>
                  </div>

                  <div className="course-meta">
                    <ul className="rattings">
                      {[1, 2, 3, 4, 5].map((star) => (
                        <li key={star}>
                          <i
                            className={
                              course.rating >= star
                                ? "fa fa-star"
                                : course.rating >= star - 0.5
                                ? "fa fa-star-half-o"
                                : "fa fa-star-o"
                            }
                          ></i>
                        </li>
                      ))}
                      <li className="point">
                        <span>{(course.rating || 4.5).toFixed(1)}</span>
                      </li>
                    </ul>

                    <div className="course-info">
                      <span>
                        <i className="fa fa-users"></i>
                        {course.enrolled || "2.4k"} Enrolled
                      </span>
                      <span>
                        <i className="fa fa-calendar-o"></i>
                        {course.duration || "2 Months"}
                      </span>
                      <span>
                        <i className="fa fa-clock-o"></i>
                        {course.timing || "09:30 - 12:00"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>

        {/* PAGINATION */}
        {!loading && filteredCourses.length > 0 && totalPages > 1 && (
          <div className="pagination-wrapper">
            <nav>
              <ul className="pagination-list">
                <li
                  className={`pagination-item ${
                    currentPage === 1 ? "disabled" : ""
                  }`}
                >
                  <button
                    className="pagination-link"
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    Previous
                  </button>
                </li>

                {renderPaginationNumbers().map((page, index) => (
                  <li
                    key={index}
                    className={`pagination-item ${
                      page === currentPage ? "active" : ""
                    } ${page === "..." ? "ellipsis" : ""}`}
                  >
                    {page === "..." ? (
                      <span className="pagination-ellipsis">...</span>
                    ) : (
                      <button
                        className="pagination-link"
                        onClick={() => handlePageChange(page)}
                      >
                        {page}
                      </button>
                    )}
                  </li>
                ))}

                <li
                  className={`pagination-item ${
                    currentPage === totalPages ? "disabled" : ""
                  }`}
                >
                  <button
                    className="pagination-link"
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    Next
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        )}
      </div>
    </section>
  );
};

export default AllCourses;
